import { api } from '../api';
import { ApiError } from '../api-error';
/** Retain uncertain writes for an identical retry. Only a rejected write unlocks editing. */
export async function alphaSave<T>(
  pending: { current: unknown },
  path: string,
  init: RequestInit,
): Promise<T> {
  try {
    return await api<T>(path, init);
  } catch (error) {
    if (error instanceof ApiError && [400, 403, 404, 409, 412, 422, 423].includes(error.statusCode))
      pending.current = null;
    throw error;
  }
}
